export default __webpack_public_path__ + "static/dodo-white-6f50634d77d99c2b91a190f571e808b8.svg";